import { CommonRouteFunctionService } from './../../services/common-routing-service';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-parent-child',
  templateUrl: './parent-child.component.html',
  styleUrls: ['./parent-child.component.scss']
})
export class ParentChildComponent implements OnInit, OnDestroy {
  parentChildData: any;
  selectedIndex: any;
  role;
  studentUserId;
  studentProfileData;
  dashboardStudentData: any;
  parentStudentId: number;
  subs: Subscription[] = [];
  loader = false;
  count: number;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private commonDataSharedService: CommonDataSharedService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonService: CommonService,
    private commonRouteFunctionService: CommonRouteFunctionService,
    private _router: Router,
    private _routes: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getParentDashboardData()
    this.role = this._commonAuthService.getRoleName().toLowerCase();

    this.subs.push(
      this.commonDataSharedService.parentHomeData.subscribe((data: any) => {
        this.parentChildData = data;
        if (data) {
          this.studentUserId = data['studentUserId'];
          this.getStudentProfileData();
        }
      }),
      this.commonDataSharedService.parentHeatMapTab.subscribe((data: any) => {
        if (data === 1) {
          this.selectedIndex = 1;
        }
      }),
      this.commonDataSharedService.updateMessageCount.subscribe((data: any) => {
        this.getCountValue();
      })
    );

    this.getCountValue();
  }


  getCountValue() {
    const inputJson = {
      userRoleData: this._commonAuthService.getRoleName(),
      userId: JSON.parse(localStorage.getItem('selectedStudentParentId'))
    };
    this._commonRequestResponseService.post('shared/get/counts', inputJson)
      .subscribe(
        (countData: any) => {
          this.count = countData.messagesCount;
        },
        (error) => {
          // this.notificationService.showSuccessErrorMessage('error', 'Error while calling service');
          /*console.error(error);*/
        }
      );
  }

  getStudentProfileData() {
    this.loader = true;
    const studentJson = {
      studentUserId: this.studentUserId,
      coachId: '0'
    };

    this._commonRequestResponseService.postWithHeader('student/studentprofile', studentJson)
      .subscribe(
        (studentData: any) => {
          this.loader = false;
          this.studentProfileData = studentData.personalInformation;
          localStorage.setItem('studentHideAssessment', studentData.hideAssessment);
          localStorage.setItem('isWebinarReservation', studentData.isWebinarReservation);
          localStorage.setItem('showMinuteVideo', studentData.showMinuteVideo);
          localStorage.setItem('classYearDescription', JSON.stringify(this.studentProfileData.classYearDescription));
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while fetching student profile data');
        });
  }

  onTabSelect(event) {
    if (event === 0) {
      this.selectedIndex = '';
    }
  }

  viewStudentDetail(value) {
    value.profileId = value.studentProfileId;
    this._commonService.setDataWithoutObservable(value, 'recentStudentDetail');
    this._router.navigate(['../coachStudentDetail'], { relativeTo: this._routes });
  }

  getParentDashboardData() {
    this.loader = true;
    this.parentStudentId = JSON.parse(localStorage.getItem('parentStudentId'));
    const inputObject = {};

    const selectedParentData = this._commonService.getDataWithoutObservable('selectedParentDataFromCoach');
    if (selectedParentData) {
      inputObject['parentProfileId'] = selectedParentData.profileId ? selectedParentData.profileId : selectedParentData.id;
    }
    this._commonRequestResponseService.postWithHeader('parent/dashboard/', inputObject)
      .subscribe(
        (dashboardData: any) => {
          this.loader = false;
          this.dashboardStudentData = dashboardData.students
          if (this.dashboardStudentData) {
            this.dashboardStudentData.forEach((item: any) => {
              if (item.studentUserId === this.parentStudentId) {
                this.parentChildData = JSON.parse(localStorage.getItem('parentChildLocalData'));
                if (this.parentChildData) {
                  this.studentUserId = this.parentChildData['studentUserId'];
                  this.getStudentProfileData();
                }

              }
            });
          }
        }, () => {
          this.loader = false;
        });
  }
  backToHome() {
    this._router.navigate(['../home'], { relativeTo: this._routes });
    this.commonRouteFunctionService.breadCrumb.next('parent/home')
  }
  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => { sub.unsubscribe() });
    localStorage.removeItem('selectedStudentParentId');
  }
}
